<template>
    <div>
        <!-- Technicien signature -->
        <div v-for="(technician, index) in technicians" :key="'technician-' + index" class="p-6 bg-white rounded-lg border border-gray-200 shadow-md mb-4">
            <h2 class="text-xl">Signature {{technician.nom}}</h2>
            <small>En signant ce bon, le client et le technicien confirment l'exactitude des données renseignées</small>
            <draw-input class="mt-2" button-label="Signer" :meta="{type: 'technicien', technicien_id: technician.id}" @submit="getTechSignature" />
        </div>

        <!-- Client signature -->
        <div class="p-6 bg-white rounded-lg border border-gray-200 shadow-md mb-4">
            <h2 class="text-xl">Signature client</h2>
            <draw-input class="mt-2" button-label="Signer" :meta="{type: 'client'}" @submit="getClientSignature" />
        </div>

        <!-- Date & heure -->
        <div v-if="dateSign" class="p-6 bg-white rounded-lg border border-gray-200 shadow-md mb-4">
            <h2 class="text-3xl">Date et heure</h2>
            <div>
                <div>
                    Date et heure arrivée:<br />
                    <b>{{dateStart}}</b>
                </div>
                Date et heure départ:<br />
                <b>{{dateSign}}</b>
            </div>
        </div>
    </div>
</template>

<script>
import DrawInput from '@/components/DrawInput.vue'

import moment from 'moment'

export default {
    props: {
        technicians: {
            type: Array,
            default: []
        },
        missionStart: {
            type: String,
            required: true,
            default: ""
        }
    },

    components: {
        DrawInput
    },

    data() {
        return {
            dateStart: null,
            dateSign: null,
            signs: [],
        }
    },

    methods: {
        getTechSignature(signature) {            
            this.dateStart = moment(this.missionStart).format("DD/MM/YYYY HH:mm");
            this.dateSign = moment().format("DD/MM/YYYY HH:mm");

            let signTech = this.signs.find(sign => (sign.type === 'technicien' && sign.technicien_id === signature.meta.technicien_id))
            signTech.signature = signature
            this.emitData()
        },

        getClientSignature(signature) {
            let signClient = this.signs.find(sign => sign.type === 'client');
            signClient.signature = signature
            this.emitData()
        },

        emitData() {
            this.$emit('input', this.signs)
        },

        initSignatures() {
            this.signs.push({type: 'client', signature: null})
            this.technicians.forEach((tech) => {
                this.signs.push({type: 'technicien', technicien_id: tech.id, signature: null})
            })
        }
    },
    mounted() {
        this.initSignatures()
    }
}
</script>

<style lang="scss" scoped>

</style>
